import { createTheme } from "../../helpers/create-theme";

export const bannerTheme = createTheme({});
